import React from "react";

const SvgCheck = props => <svg width="1em" height="1em" viewBox="0 0 16 13" fill="none" {...props}><path d="M14.299 0c-.43.013-.838.192-1.137.5-2.617 2.623-5.006 5.194-7.52 7.76L2.688 5.893A1.655 1.655 0 10.621 8.476l4.134 3.307a1.654 1.654 0 002.205-.129c2.974-2.98 5.638-5.907 8.544-8.82A1.654 1.654 0 0014.3.001z" fill="currentColor" /></svg>;

export default SvgCheck;